
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/columns/companies/[id]",
      function () {
        return require("private-next-pages/columns/companies/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/columns/companies/[id]"])
      });
    }
  